var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackArrow = function SvgBackArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.875 10C19.875 15.4538 15.4538 19.875 10 19.875C4.54619 19.875 0.125 15.4538 0.125 10C0.125 4.54619 4.54619 0.125 10 0.125C15.4538 0.125 19.875 4.54619 19.875 10ZM13 15.0239C13 14.6608 12.8296 14.3435 12.5675 14.1196L8.34107 10.115L12.504 6.17048C12.799 5.94664 13 5.61477 13 5.22723C13 4.54902 12.4253 4 11.7142 4C11.3581 4 11.0372 4.1392 10.8045 4.36193L5.6167 9.28198C5.39221 9.50136 5.25 9.79648 5.25 10.125C5.25 10.4491 5.38986 10.7386 5.60847 10.9569L10.7963 15.8769C11.029 16.1052 11.3534 16.25 11.7142 16.25C12.4253 16.25 13 15.701 13 15.0239Z",
    fill: "#717171"
  })));
};
export default SvgBackArrow;